import React from "react";
import PropTypes from "prop-types";

export default function FacebookPlatform(props) {
  return (
    <svg
      className={props.className}
      width={props.width}
      height={props.height}
      viewBox={`0 0 ${props.width} ${props.height}`}
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M38.4091 19.5C38.4091 8.73209 29.8093 0 19.2045 0C8.59979 0 0 8.73209 0 19.5C0 30.2679 8.59979 39 19.2045 39C19.3174 39 19.4296 38.9976 19.5421 38.9955V23.8156H15.4161V18.9332H19.5421V15.3403C19.5421 11.1735 22.0473 8.90556 25.7079 8.90556C27.4609 8.90556 28.9677 9.03827 29.407 9.09748V13.4524H26.8827C24.8912 13.4524 24.5056 14.4134 24.5056 15.8235V18.9332H29.2675L28.6468 23.8156H24.5056V38.2469C32.5328 35.9103 38.4091 28.4008 38.4091 19.5Z"
        fill="#275AE7"
      />
      <path
        d="M56.2956 21.7316H64.3737V19.7364H56.2956V12.9381H65.1257V10.8937H54.0396V29.7368H56.2956V21.7316Z"
        fill="#275AE7"
      />
      <path
        d="M71.8786 28.1604C70.4959 28.1604 69.6468 27.4461 69.6468 26.116C69.6468 25.4263 69.8652 24.8844 70.3503 24.5149C71.1751 23.8992 72.7519 23.6775 75.5174 23.5543V23.8499C75.5174 27.052 73.5039 28.1604 71.8786 28.1604ZM70.1805 20.3029C70.2533 19.1945 70.9568 18.0861 72.849 18.0861C74.6441 18.0861 75.5174 18.9975 75.5174 21.3375V21.904C72.6549 22.0025 70.6657 22.2488 69.3315 22.9632C68.0215 23.6282 67.4151 24.8105 67.4151 26.2392C67.4151 28.5545 68.9191 29.9585 71.4662 29.9585C73.3584 29.9585 74.8867 29.0718 75.5659 27.5446H75.6144C75.8327 29.0964 76.512 29.8354 78.5497 29.8354H78.8165V28.0373C77.8704 28.0126 77.6521 27.5939 77.6521 26.5594V21.2636C77.6521 17.7905 76.0996 16.4358 72.9217 16.4358C69.8652 16.4358 68.1428 18.0122 68.0943 20.3029H70.1805Z"
        fill="#275AE7"
      />
      <path
        d="M91.7612 20.6724C91.5429 17.6181 89.2383 16.4358 86.6912 16.4358C83.101 16.4358 80.9662 19.3423 80.9662 23.308C80.9662 27.4215 82.9554 30.0324 86.6427 30.0324C89.4081 30.0324 91.5186 28.5053 91.834 25.5002H89.7963C89.7235 26.4855 89.0928 28.3082 86.6669 28.3082C84.0956 28.3082 83.198 26.2145 83.198 23.2095C83.198 20.1798 84.4109 18.1354 86.7155 18.1354C88.5591 18.1354 89.4809 19.3423 89.6265 20.6724H91.7612Z"
        fill="#275AE7"
      />
      <path
        d="M102.896 22.1011H96.3464C96.6133 19.7364 97.7291 18.1107 99.7668 18.1107C101.999 18.1107 102.848 19.7857 102.896 21.9533V22.1011ZM104.958 26.3377H102.848C102.629 27.1013 102.071 28.3575 99.9367 28.3575C97.5351 28.3575 96.4677 26.5347 96.3222 23.8499H105.128V22.7168C105.128 19.4408 103.624 16.4358 99.7911 16.4358C96.1281 16.4358 94.0904 19.4655 94.0904 23.308C94.0904 27.1752 95.9583 30.0571 99.8639 30.0571C102.605 30.0571 104.497 28.5792 104.958 26.3377Z"
        fill="#275AE7"
      />
      <path
        d="M108.568 29.7368H110.63V27.6678H110.678C111.333 28.924 112.668 30.0571 114.681 30.0571C117.568 30.0571 119.945 27.7909 119.945 23.0617C119.945 18.1354 117.519 16.4358 114.802 16.4358C112.886 16.4358 111.479 17.4949 110.775 18.8989H110.751V10.3272H108.568V29.7368ZM114.341 28.3082C111.916 28.3082 110.678 26.2884 110.678 23.7267V22.3474C110.678 20.1552 112.013 18.2093 114.317 18.2093C116.937 18.2093 117.738 20.3029 117.738 23.0617C117.738 26.4608 116.622 28.3082 114.341 28.3082Z"
        fill="#275AE7"
      />
      <path
        d="M128.195 30.0571C131.785 30.0571 133.944 27.2983 133.944 23.2341C133.944 19.2192 132.052 16.4358 128.244 16.4358C124.678 16.4358 122.494 19.2192 122.494 23.2341C122.494 27.2983 124.435 30.0571 128.195 30.0571ZM128.219 18.1354C130.67 18.1354 131.688 20.0813 131.688 23.2341C131.688 26.4116 130.645 28.3328 128.268 28.3328C125.794 28.3328 124.751 26.4116 124.751 23.2341C124.751 20.0813 125.891 18.1354 128.219 18.1354Z"
        fill="#275AE7"
      />
      <path
        d="M142.196 30.0571C145.786 30.0571 147.945 27.2983 147.945 23.2341C147.945 19.2192 146.053 16.4358 142.244 16.4358C138.678 16.4358 136.495 19.2192 136.495 23.2341C136.495 27.2983 138.436 30.0571 142.196 30.0571ZM142.22 18.1354C144.67 18.1354 145.689 20.0813 145.689 23.2341C145.689 26.4116 144.646 28.3328 142.269 28.3328C139.794 28.3328 138.751 26.4116 138.751 23.2341C138.751 20.0813 139.891 18.1354 142.22 18.1354Z"
        fill="#275AE7"
      />
      <path
        d="M153.582 25.7712L155.717 23.3326L159.453 29.7368H162L157.197 21.6331L161.466 16.756H158.919L153.582 23.0124V10.3272H151.399V29.7368H153.582V25.7712Z"
        fill="#275AE7"
      />
    </svg>
  );
}

FacebookPlatform.propTypes = {
  className: PropTypes.string,
  width: PropTypes.number,
  height: PropTypes.number
};

FacebookPlatform.defaultProps = {
  className: "",
  width: 40,
  height: 40
};
